module.exports = {
  COGNITO: {
    ACCOUNT_STATUS: {
      CONFIRMED: 'CONFIRMED'
    }
  }
};
